// extracted by mini-css-extract-plugin
export default {"contenedor":"LaboralesModal_contenedor__FNM45"};